import { StitchError } from "../../src/spec/errors.js";
/** A generated UI screen. Provides access to HTML and screenshots. */
export class Screen {
    client;
    projectId;
    screenId;
    data;
    constructor(client, data) {
        this.client = client;
        this.projectId = typeof data === "string" ? data : data.projectId;
        this.screenId = typeof data === "string" ? data : data.id;
        if (!this.screenId && typeof data === "object" && data.name) {
            const parts = data.name.split("/screens/");
            if (parts.length === 2)
                this.screenId = parts[1];
        }
        this.data = typeof data === "object" ? data : undefined;
    }
    /** Convenience alias for screenId */
    get id() {
        return this.screenId;
    }
    /**
     * Edits existing screens within a project using a text prompt.
     * Tool: edit_screens
     */
    async edit(prompt, deviceType, modelId) {
        try {
            const raw = await this.client.callTool("edit_screens", { projectId: this.projectId, selectedScreenIds: [this.screenId], prompt, deviceType, modelId });
            const _projected = (raw?.outputComponents ?? []).find((c) => c?.design?.screens != null)?.design?.screens?.[0];
            if (!_projected)
                throw new StitchError({ code: "UNKNOWN_ERROR", message: "Incomplete API response from edit_screens: expected object at projection path", recoverable: false });
            return new Screen(this.client, { ..._projected, projectId: this.projectId });
        }
        catch (error) {
            throw StitchError.fromUnknown(error);
        }
    }
    /**
     * Generates variants of existing screens within a project using a text prompt.
     * Tool: generate_variants
     */
    async variants(prompt, variantOptions, deviceType, modelId) {
        try {
            const raw = await this.client.callTool("generate_variants", { projectId: this.projectId, selectedScreenIds: [this.screenId], prompt, variantOptions, deviceType, modelId });
            return ((raw.outputComponents || []).flatMap((a) => a?.design?.screens || []) || []).map((item) => new Screen(this.client, { ...item, projectId: this.projectId }));
        }
        catch (error) {
            throw StitchError.fromUnknown(error);
        }
    }
    /**
     * Retrieves the details of a specific screen within a project.
     * Tool: get_screen
     */
    async getHtml() {
        // Use cached HTML download URL from generation response if available
        if (this.data?.htmlCode?.downloadUrl)
            return this.data?.htmlCode?.downloadUrl;
        try {
            const raw = await this.client.callTool("get_screen", { projectId: this.projectId, screenId: this.screenId, name: `projects/${this.projectId}/screens/${this.screenId}` });
            return raw?.htmlCode?.downloadUrl || "";
        }
        catch (error) {
            throw StitchError.fromUnknown(error);
        }
    }
    /**
     * Retrieves the details of a specific screen within a project.
     * Tool: get_screen
     */
    async getImage() {
        // Use cached screenshot URL from generation response
        if (this.data?.screenshot?.downloadUrl)
            return this.data?.screenshot?.downloadUrl;
        try {
            const raw = await this.client.callTool("get_screen", { projectId: this.projectId, screenId: this.screenId, name: `projects/${this.projectId}/screens/${this.screenId}` });
            return raw?.screenshot?.downloadUrl || "";
        }
        catch (error) {
            throw StitchError.fromUnknown(error);
        }
    }
}
//# sourceMappingURL=screen.js.map